import { LinkComponent } from './questionnaire/link/link.component';
import { ContinueComponent } from './questionnaire/continue/continue.component';
import { HelpComponent } from './main/help/help.component';
import { ResultComponent } from './questionnaire/result/result.component';
import { FinishedComponent } from './questionnaire/finished/finished.component';
import { TippsComponent } from './intro/tipps/tipps.component';
import { DataPolicyComponent } from './main/data-policy/data-policy.component';
import { ImprintComponent } from './main/imprint/imprint.component';
import { LinksComponent } from './main/links/links.component';
import { QuestionComponent } from './questionnaire/question/question.component';
import { IntroStartComponent } from './intro/intro-start/intro-start.component';
import { IntroIndexComponent } from './intro/intro-index/intro-index.component';
import { StartComponent } from './questionnaire/start/start.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', component: IntroIndexComponent},
  { path: 'questionnaire/start',  component: StartComponent },
  { path: 'questionnaire/question',  component: QuestionComponent },
  { path: 'questionnaire/finished',  component: FinishedComponent },
  { path: 'questionnaire/continue',  component: ContinueComponent },
  { path: 'questionnaire/result',  component: ResultComponent },
  { path: 'intro/index',  component: IntroIndexComponent },
  { path: 'main/help',  component: HelpComponent },
  { path: 'links',  component: LinksComponent },
  { path: 'imprint',  component: ImprintComponent },
  { path: 'data-policy',  component: DataPolicyComponent },
  { path: 'questionnaire/link',  component: LinkComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
